import React from 'react';

const About = () => {
    return (
        <section id="about" className="about">
            <p>I am a student studying Computer Science, Math, and minoring in Philosophy. </p>
            <p>I am the product of a great education, and I want to make that the standard. </p>
        </section>
    );
};

export default About;
